import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { UserPlus } from "lucide-react";

const EMPTY_NEW = { first_name: "", last_name: "", email: "", phone: "", address: { street: "", city: "", state: "", zip: "", country: "" } };

export const AddCustomerDialog = ({ open, onOpenChange, onCreated }) => {
  const [cust, setCust] = useState(EMPTY_NEW);

  const patch = (p) => setCust((c) => ({ ...c, ...p }));
  const patchAddr = (field, val) => setCust((c) => ({ ...c, address: { ...c.address, [field]: val } }));

  const save = async () => {
    if (!cust.first_name && !cust.last_name && !cust.email) {
      toast.error("Please enter at least a name or an email.");
      return;
    }
    try {
      const { data } = await api.post("/customers", { ...cust, email: cust.email || null });
      toast.success("Customer added.");
      onOpenChange(false);
      setCust(EMPTY_NEW);
      onCreated(data);
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button data-testid="add-customer-btn"><UserPlus className="h-4 w-4 mr-2" /> Add a Customer</Button>
      </DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle className="font-serif text-2xl">Add a Customer</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1.5"><Label>First name</Label><Input data-testid="new-customer-first-name" value={cust.first_name} onChange={(e) => patch({ first_name: e.target.value })} /></div>
          <div className="space-y-1.5"><Label>Last name</Label><Input data-testid="new-customer-last-name" value={cust.last_name} onChange={(e) => patch({ last_name: e.target.value })} /></div>
          <div className="space-y-1.5 col-span-2"><Label>Email</Label><Input data-testid="new-customer-email" type="email" value={cust.email} onChange={(e) => patch({ email: e.target.value })} /></div>
          <div className="space-y-1.5 col-span-2"><Label>Phone</Label><Input value={cust.phone} onChange={(e) => patch({ phone: e.target.value })} /></div>
          <div className="space-y-1.5 col-span-2"><Label>Street address</Label><Input value={cust.address.street} onChange={(e) => patchAddr("street", e.target.value)} /></div>
          <div className="space-y-1.5"><Label>City</Label><Input value={cust.address.city} onChange={(e) => patchAddr("city", e.target.value)} /></div>
          <div className="space-y-1.5"><Label>State</Label><Input value={cust.address.state} onChange={(e) => patchAddr("state", e.target.value)} /></div>
          <div className="space-y-1.5"><Label>ZIP code</Label><Input value={cust.address.zip} onChange={(e) => patchAddr("zip", e.target.value)} /></div>
          <div className="space-y-1.5"><Label>Country</Label><Input value={cust.address.country} onChange={(e) => patchAddr("country", e.target.value)} /></div>
        </div>
        <DialogFooter>
          <Button onClick={save} data-testid="save-new-customer-btn">Save customer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
